import { render, staticRenderFns } from "./SubmitOrder.vue?vue&type=template&id=7bb03cda&scoped=true"
import script from "./SubmitOrder.vue?vue&type=script&lang=js"
export * from "./SubmitOrder.vue?vue&type=script&lang=js"
import style0 from "./SubmitOrder.vue?vue&type=style&index=0&id=7bb03cda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb03cda",
  null
  
)

export default component.exports